import React, { useEffect, useState } from "react";
import { Modal } from "../../ui/Modal/Modal";
import styles from "./ModalBitrixIntegrationForm.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Title from "../../ui/Title/Title";
import { BitrixIcon } from "../../assets/icons/BitrixIcon";
import Input from "../../ui/Input/Input";
import Button from "../../ui/Button/Button";
import { ClipLoader } from "react-spinners";
import {
  setActiveBitrix,
  setNewBitrix,
} from "../../store/slices/integrationSlice";
import {
  stepsDataBitrixURL,
  stepsDataIncoming,
  stepsDataOutgoing,
} from "../../assets/consts/tooltipDataBitrix";
import { useModal } from "../../context/ModalContext";
import {
  getIntegrationsBitrixList,
  initBitrix,
} from "../../utils/api/actions/integrations/bitrix";
import CopyableTextField from "./CopyableTextField/CopyableTextField";
import { TooltipProvider } from "../../context/TooltipContext";
import { BlockTooltip } from "../BlockTooltip/BlockTooltip";

const BitrixSuccessMessage = ({ closeModal, closeAddIntegrationModal }) => {
  const [countdown, setCountdown] = useState(5);
  const dispatch = useDispatch();

  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    if (countdown === 0) {
      closeModal();
      closeAddIntegrationModal();
      dispatch(getIntegrationsBitrixList(id));
      dispatch(setActiveBitrix(null));
      dispatch(setNewBitrix(null));
    }

    return () => clearInterval(timer);
  }, [countdown, closeModal, dispatch, id, closeAddIntegrationModal]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили Bitrix!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

export const ModalBitrixIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();
  const { closeModal } = useModal();

  const user = useSelector((state) => state?.user?.data);

  const [isBitrixConnected, setIsBitrixConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [apiUrl, setApiUrl] = useState("");
  const [appToken, setAppToken] = useState("");
  const [error, setError] = useState("");

  const hintBitrixOutgoing = {
    id: "bitrix",
    stepsData: stepsDataOutgoing,
  };

  const hintBitrixIncoming = {
    id: "bitrix",
    stepsData: stepsDataIncoming,
  };

  const hintURL = {
    id: "bitrixURL",
    stepsData: stepsDataBitrixURL,
  };

  const handleAppTokenChange = (e) => setAppToken(e.target.value);
  const handleApiUrlChange = (e) => setApiUrl(e.target.value);

  const handleSendDataInitBitrix = () => {
    if (!apiUrl.trim() || !appToken.trim()) {
      setError("Пожалуйста, заполните все поля.");
      return;
    }
    setError("");
    setLoading(true);

    dispatch(
      initBitrix(
        { userId: user.id, apiURL: apiUrl, appToken },
        setLoading,
        setIsBitrixConnected,
        setError
      )
    );
  };

  const handleKeyDown = (e, field) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const fields = ["appToken", "apiUrl"];
      const values = { appToken, apiUrl };
      const currentIndex = fields.indexOf(field);

      if (currentIndex < fields.length - 1) {
        // Переключаем фокус на следующее поле
        document.getElementById(fields[currentIndex + 1])?.focus();
      } else {
        // Если в последнем поле и все заполнены — отправляем данные
        if (Object.values(values).every((val) => val.trim() !== "")) {
          handleSendDataInitBitrix();
        } else {
          setError("Заполните все поля");
        }
      }
    }
  };

  return (
    <Modal
      styleClose={styles.closeIcon}
      visible={visible}
      handleClose={handlerClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <BitrixIcon width={75} height={55} fill={"#3e8fcb"} />
        </div>
        {isBitrixConnected ? (
          <BitrixSuccessMessage
            closeModal={handlerClose}
            closeAddIntegrationModal={closeModal}
          />
        ) : (
          <div className={styles.form}>
            <div className={styles.copyField}>
              <div className={styles.titleContainer}>
                <label className={styles.label}>URL вашего обработчика</label>
                <TooltipProvider>
                  {hintURL && (
                    <BlockTooltip
                      className={styles.tooltip}
                      tooltipId={hintURL.id}
                      stepsData={hintURL.stepsData}
                    />
                  )}
                </TooltipProvider>
              </div>
              <CopyableTextField
                text={`https://digital.tab-is.com:2082/integrations/bitrix/crm-update-handler?userId=${user.id}`}
              />
            </div>

            <div className={styles.inputContainer}>
              <Input
                id="appToken"
                onKeyPress={(e) => handleKeyDown(e, "appToken")}
                className={styles.child}
                label="Токен приложения"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={`${styles.input} ${error ? styles.error : ""}`}
                value={appToken}
                placeholder={"Токен"}
                type={"text"}
                hint={hintBitrixOutgoing}
                onChange={handleAppTokenChange}
              />
            </div>

            <div className={styles.inputContainer}>
              <Input
                id="apiUrl"
                onKeyPress={(e) => handleKeyDown(e, "apiUrl")}
                className={styles.child}
                label="Вебхук для вызова rest api"
                labelStyle={styles.labelInput}
                backgroundStyle={styles.labelBackground}
                inputStyle={`${styles.input} ${error ? styles.error : ""}`}
                value={apiUrl}
                placeholder={"URL"}
                type={"text"}
                hint={hintBitrixIncoming}
                onChange={handleApiUrlChange}
                classNameTooltip={styles.tooltipURL}
              />
            </div>

            {error && <div className={styles.errorMessage}>{error}</div>}

            <Button
              onClick={handleSendDataInitBitrix}
              className={styles.button}
              titleClassName={styles.buttonTitle}
              leftIcon={
                loading ? <ClipLoader size={16} color={"white"} /> : null
              }
              title={loading ? "Подождите..." : "Отправить"}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
